import { configureStore } from "@reduxjs/toolkit";
import requestCVDialogueReducer from "@AdbhutByte/utils/config/ui/state/slices/requestCVDialogueSlice";
import socialDialogueReducer from "@AdbhutByte/utils/config/ui/state/slices/socialDialogueSlice";

export const store = configureStore({
  reducer: {
    requestCVDialogueReducer,
    socialDialogueReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
